import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

const getPrepaymentSuggestion = async (ctx: QueryFunctionContext) => {
  const {data}: {data: Array<IPrepaymentSuggestion>} = await request.get(
    `/api/v2/market/prepayment-suggestion?post_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
export default getPrepaymentSuggestion;
